module.exports = __webpack_public_path__ + "media/images/countryrect/dz-5bee543f805221a9e2dd0dd895792706.svg";